import { useRef } from 'react';
import { Container, HStack, IconButton, Drawer, CloseButton, Portal, Flex, Image } from '@chakra-ui/react';
import type { ContainerProps } from '@chakra-ui/react';
import { LuAlignRight } from 'react-icons/lu';
import { Link } from 'react-router';
import StageBookLogo from '@/assets/stagebook_logo.webp';

import Sidebar from './Sidebar';

const Navbar = (props: ContainerProps) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  const handleCloseDrawer = () => {
    closeButtonRef.current?.click();
  };

  return (
    <Container bg="white" py="2.5" {...props}>
      <HStack justify="space-between">
        <Link to="/painel/agendas">
          <Flex justifyContent="center">
            <Image src={StageBookLogo} alt="StageBook Logo" width={120} />
          </Flex>
        </Link>
        <Drawer.Root placement="start">
          <Drawer.Trigger asChild>
            <IconButton aria-label="Open Menu" variant="ghost" colorPalette="gray">
              <LuAlignRight />
            </IconButton>
          </Drawer.Trigger>
          <Portal>
            <Drawer.Backdrop />
            <Drawer.Positioner>
              <Drawer.Content>
                <Drawer.CloseTrigger asChild>
                  <CloseButton size="sm" colorPalette="gray" ref={closeButtonRef} />
                </Drawer.CloseTrigger>
                <Sidebar onClose={handleCloseDrawer} />
              </Drawer.Content>
            </Drawer.Positioner>
          </Portal>
        </Drawer.Root>
      </HStack>
    </Container>
  );
};

export default Navbar;
